import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import axios from 'axios';
import api from '../../API/api';

const debug = false;
const baseUrl = debug ? "http://localhost:8000/api/token/" : "https://api.alumni.uem.mz/api/token/";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    
    try {
      const credentials = {
        email: email,
        password: password,
      };

      const response = await axios.post(baseUrl, credentials, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response.data;

      localStorage.setItem("access_token", data.access);
      localStorage.setItem("refresh_token", data.refresh);

      // Buscar dados do usuário
      const res = await api.get("v1/users/my/");
      localStorage.setItem("me", JSON.stringify(res.data));

      setLoading(false);
      
      notification.success({
        message: "Bem-vindo!",
        description: "Login realizado com sucesso.",
        placement: "topRight",
        duration: 3,
      });

      const from = location.state?.from;
      navigate(from || "/feed", { replace: true });
    } catch (error) {
      setLoading(false);

      if (error.response) {
        if (error.response.status === 401 || error.response.status === 400) {
          setError("Combinação de email e senha errada!");
          notification.error({
            message: "Erro de Autenticação",
            description: "Combinação de email e senha errada!",
            placement: "topRight",
            duration: 3,
          });
        } else {
          setError(error.response.data?.detail || "Algo correu mal. Tente novamente!");
          notification.error({
            message: `Erro ${error.response.status}`,
            description: error.response.data?.detail || "Algo correu mal. Tente novamente!",
            placement: "topRight",
            duration: 3,
          });
        }
      } else if (error.request) {
        setError("Verifique sua conexão com a internet");
        notification.error({
          message: "Erro de Conexão",
          description: "Verifique sua conexão com a internet",
          placement: "topRight",
          duration: 3,
        });
      } else {
        setError(error.message || "Algo correu mal!");
        notification.error({
          message: "Erro",
          description: error.message || "Algo correu mal!",
          placement: "topRight",
          duration: 3,
        });
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA] p-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-md border border-gray-100 p-6">
        <div className="flex items-center gap-3 mb-4">
          <img 
            src={require('../../assets/logo/logo-v2.png')} 
            className="w-12 h-12" 
            alt="Alumni Logo"
          />
          <div>
            <div className="text-2xl font-bold text-emerald-700">Alumni</div>
            <div className="text-sm text-black">Portal do Graduado</div>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-sm text-gray-700 mb-1">E-mail</label>
            <input
              type="email"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-600"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nome@dominio.com"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm text-gray-700 mb-1">Palavra‑passe</label>
            <input
              type="password"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-600"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          
          <div className="flex items-center justify-between">
            <label className="flex items-center gap-2 text-sm text-gray-700">
              <input 
                type="checkbox" 
                checked={remember} 
                onChange={(e) => setRemember(e.target.checked)} 
              />
              Manter sessão iniciada
            </label>
            <button
              type="button"
              onClick={() => navigate('/account/recuperar-senha')}
              className="text-sm text-emerald-600 hover:text-emerald-700"
            >
              Esqueceu a palavra‑passe?
            </button>
          </div>
          
          {error && (
            <div className="text-sm text-red-600 bg-red-50 p-2 rounded-md">
              {error}
            </div>
          )}
          
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-emerald-700 hover:bg-emerald-800 text-white py-2 rounded-md disabled:opacity-60 transition-colors"
          >
            {loading ? 'A validar…' : 'Iniciar sessão'}
          </button>
        </form>
        
        <div className="mt-4 text-center text-sm text-gray-600">
          Não tem conta?{' '}
          <button
            type="button"
            onClick={() => navigate('/inscricao')}
            className="text-emerald-600 hover:text-emerald-700 font-medium"
          >
            Registre-se
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;